export default __webpack_public_path__ + "static/media/(34).3e0c15f9.jpg";